import React from 'react'
import { Table } from 'antd'
import './CommonTable.css'

const CommonTable = ({
  columns,
  dataSource,
  rowKey,
  pagination = { pageSize: 10 },
  loading = false,
  size = 'middle',
  scroll,
  ...restProps
}) => {
  // Add sorter and ellipsis to all columns if not specified
  const enhancedColumns = columns.map((col) => ({
    ellipsis: true,
    sorter: col.sorter !== false ? (a, b) => {
      const aVal = a[col.dataIndex]
      const bVal = b[col.dataIndex]
      
      if (typeof aVal === 'number' && typeof bVal === 'number') {
        return aVal - bVal
      }
      
      return (aVal || '').toString().localeCompare((bVal || '').toString())
    } : undefined,
    ...col,
  }))

  return (
    <Table
      className="common-table"
      columns={enhancedColumns}
      dataSource={dataSource}
      rowKey={rowKey}
      pagination={pagination}
      loading={loading}
      size={size}
      scroll={scroll}
      bordered
      {...restProps}
    />
  )
}

export default CommonTable
